<div class="container-fluid client-list-container">
  <div class="row my-3">
    <div class="col">
        <div class="card p-2">
          <div>
            <button (click)="exportData()" class="btn btn-primary" style="position: absolute; right: 15px; width: 150px; height: 30px; padding: 0px; z-index: 10">Export</button>
          </div>
          <app-data-table [columns]="columns" [loadPage]="loadPage" [(filters)]="filters"
            [filtersComponent]="dataFilters" [pageSize]="20" (onReset)="onTableReset()" [tBodyTrAdditionalClass]="tBodyTrAdditionalClass">
            <app-data-filters #dataFilters>
              <app-data-filter-group>
                <app-data-filter-input label="Customer Name" [(model)]="filters.customerName"
                  placeholder="Customer Name">
                </app-data-filter-input>
                <app-data-filter-input label="Company Name" [(model)]="filters.company"
                  placeholder="Company Name">
                </app-data-filter-input>
                <app-data-filter-datepicker label="Start Date" [(model)]="filters.startDate"
                  placeholder="Start Date">
                </app-data-filter-datepicker>
                <app-data-filter-datepicker label="End Date" [(model)]="filters.endDate"
                  placeholder="End Date">
                </app-data-filter-datepicker>
                <app-data-filter-datepicker label="Created At" [(model)]="filters.createdAt"
                  placeholder="Created At">
                </app-data-filter-datepicker>
              </app-data-filter-group>
            </app-data-filters>
          </app-data-table>
          <ng-template #eventName let-eventName="eventName">
            {{eventName}}
          </ng-template>

          <ng-template #customerName let-clientUser="clientUser">
            {{clientUser.firstName}} {{clientUser.lastName}}
          </ng-template>

          <ng-template #companyName let-clientUser="clientUser">
            {{clientUser.company.name}}
          </ng-template>

          <ng-template #startDate let-startDate="startDate">
            {{startDate}}
          </ng-template>

          <ng-template #endDate let-endDate="endDate">
            {{endDate}}
          </ng-template>

          <ng-template #eventDays let-startDate="startDate" let-endDate="endDate">
            {{getEventDays(startDate, endDate)}}
          </ng-template>

          <ng-template #createdAt let-createdAt="createdAt">
            {{createdAt | date : 'yyyy-MM-dd'}}
          </ng-template>

          <ng-template #eventPrice let-eventId="id">
            {{getFullPrice(eventId) | number : '1.2-2'}}
          </ng-template>

          <ng-template #softwareWaiter let-software="requestedSoftwareTypes">
            {{getSoftwareTypes(software, 'waiter')}}
          </ng-template>

          <ng-template #softwareCashRegister let-software="requestedSoftwareTypes">
            {{getSoftwareTypes(software, 'cashregister')}}
          </ng-template>

          <ng-template #softwareMainDevice let-software="requestedSoftwareTypes">
            {{getSoftwareTypes(software, 'maindevice')}}
          </ng-template>

          <ng-template #softwarePrinter let-software="requestedSoftwareTypes">
            {{getSoftwareTypes(software, 'printer')}}
          </ng-template>

          <ng-template #hardwarePhone let-requestedDevices="requestedDevices">
            {{getDeviceTypes(requestedDevices, 'phone')}}
          </ng-template>

          <ng-template #hardwareTablet let-requestedDevices="requestedDevices">
            {{getDeviceTypes(requestedDevices, 'tablet')}}
          </ng-template>

          <ng-template #hardwarePrinter let-printers="printers">
            {{printers.length}}
          </ng-template>

          <ng-template #hardwareRouter let-routers="requestedRouterTypes">
            {{routers[0] ? routers[0].quantity : 0}}
          </ng-template>

          <ng-template #badWeather let-eventId="id">
            {{getAdditionalCosts(eventId, 1)}}
          </ng-template>

          <ng-template #cancellation let-eventId="id">
            {{getAdditionalCosts(eventId, 2)}}
          </ng-template>

          <ng-template #cashDrawer let-eventId="id">
            {{getAdditionalCosts(eventId, 3)}}
          </ng-template>

          <ng-template #beltBag let-eventId="id">
            {{getAdditionalCosts(eventId, 4)}}
          </ng-template>

          <ng-template #wallet let-eventId="id">
            {{getAdditionalCosts(eventId, 5)}}
          </ng-template>

          <ng-template #pickupInstalled let-eventId="id">
            {{getAdditionalCosts(eventId, 6)}}
          </ng-template>

          <ng-template #uploadingCheckingPricelist let-eventId="id">
            {{getAdditionalCosts(eventId, 7)}}
          </ng-template>

          <ng-template #training let-eventId="id">
            {{getAdditionalCosts(eventId, 8)}}
          </ng-template>

          <ng-template #vivaWallet let-eventId="id">
            {{getAdditionalCosts(eventId, 9)}}
          </ng-template>

          <ng-template #sumUp let-eventId="id">
            {{getAdditionalCosts(eventId, 10)}}
          </ng-template>

          <ng-template #stockManagement let-eventId="id">
            {{getAdditionalCosts(eventId, 11)}}
          </ng-template>

          <ng-template #sticker let-eventId="id">
            {{getAdditionalCosts(eventId, 12)}}
          </ng-template>

          <ng-template #worldLine let-eventId="id">
            {{getAdditionalCosts(eventId, 13)}}
          </ng-template>

          <ng-template #tapToPayHelp let-eventId="id">
            {{getAdditionalCosts(eventId, 14)}}
          </ng-template>
        </div>
    </div>
  </div>
</div>
